"use strict";

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "prop-types"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("prop-types"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.propTypes);
    global.undefined = mod.exports;
  }
})(void 0, function (exports, _propTypes) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.heightWidthRadiusDefaults = exports.heightWidthDefaults = exports.sizeMarginDefaults = exports.sizeDefaults = exports.heightWidthRadiusProps = exports.heightWidthProps = exports.sizeMarginProps = exports.sizeProps = exports.heightWidthRadiusKeys = exports.heightWidthKeys = exports.sizeMarginKeys = exports.sizeKeys = undefined;

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _common, _size, _heightWidth, _Object$assign2, _commonValues;

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  /*
   * List of string constants to represent different props
   */
  var LOADING = 'loading';
  var COLOR = 'color';
  var CSS = 'css';
  var SIZE = 'size';
  var SIZE_UNIT = 'sizeUnit';
  var WIDTH = 'width';
  var WIDTH_UNIT = 'widthUnit';
  var HEIGHT = 'height';
  var HEIGHT_UNIT = 'heightUnit';
  var RADIUS = 'radius';
  var RADIUS_UNIT = 'radiusUnit';
  var MARGIN = 'margin';
  /*
   * Array for onlyUpdateForKeys function
   */

  var commonStrings = [LOADING, COLOR, CSS];
  var sizeStrings = [SIZE, SIZE_UNIT];
  var heightWidthString = [HEIGHT, HEIGHT_UNIT, WIDTH, WIDTH_UNIT];
  var sizeKeys = exports.sizeKeys = commonStrings.concat(sizeStrings);
  var sizeMarginKeys = exports.sizeMarginKeys = sizeKeys.concat([MARGIN]);
  var heightWidthKeys = exports.heightWidthKeys = commonStrings.concat(heightWidthString);
  var heightWidthRadiusKeys = exports.heightWidthRadiusKeys = heightWidthKeys.concat([RADIUS, RADIUS_UNIT, MARGIN]);
  /*
   * PropType object for different loaders
   */

  var precompiledCssType = _propTypes2["default"].shape({
    name: _propTypes2["default"].string,
    styles: _propTypes2["default"].string
  });

  var common = (_common = {}, _defineProperty(_common, LOADING, _propTypes2["default"].bool), _defineProperty(_common, COLOR, _propTypes2["default"].string), _defineProperty(_common, CSS, _propTypes2["default"].oneOfType([_propTypes2["default"].string, precompiledCssType])), _common);
  var size = (_size = {}, _defineProperty(_size, SIZE, _propTypes2["default"].number), _defineProperty(_size, SIZE_UNIT, _propTypes2["default"].string), _size);
  var heightWidth = (_heightWidth = {}, _defineProperty(_heightWidth, WIDTH, _propTypes2["default"].number), _defineProperty(_heightWidth, WIDTH_UNIT, _propTypes2["default"].string), _defineProperty(_heightWidth, HEIGHT, _propTypes2["default"].number), _defineProperty(_heightWidth, HEIGHT_UNIT, _propTypes2["default"].string), _heightWidth);
  var sizeProps = exports.sizeProps = Object.assign({}, common, size);
  var sizeMarginProps = exports.sizeMarginProps = Object.assign({}, sizeProps, _defineProperty({}, MARGIN, _propTypes2["default"].string));
  var heightWidthProps = exports.heightWidthProps = Object.assign({}, common, heightWidth);
  var heightWidthRadiusProps = exports.heightWidthRadiusProps = Object.assign({}, heightWidthProps, (_Object$assign2 = {}, _defineProperty(_Object$assign2, RADIUS, _propTypes2["default"].number), _defineProperty(_Object$assign2, RADIUS_UNIT, _propTypes2["default"].string), _defineProperty(_Object$assign2, MARGIN, _propTypes2["default"].string), _Object$assign2));
  /*
   * DefaultProps object for different loaders
   */

  var commonValues = (_commonValues = {}, _defineProperty(_commonValues, LOADING, true), _defineProperty(_commonValues, COLOR, '#000000'), _defineProperty(_commonValues, CSS, {}), _commonValues);

  var heightWidthValues = function heightWidthValues(height, width) {
    var _ref;

    return _ref = {}, _defineProperty(_ref, HEIGHT, height), _defineProperty(_ref, HEIGHT_UNIT, 'px'), _defineProperty(_ref, WIDTH, width), _defineProperty(_ref, WIDTH_UNIT, 'px'), _ref;
  };

  var sizeValues = function sizeValues(sizeValue) {
    var _ref2;

    return _ref2 = {}, _defineProperty(_ref2, SIZE, sizeValue), _defineProperty(_ref2, SIZE_UNIT, 'px'), _ref2;
  };

  var sizeDefaults = exports.sizeDefaults = function sizeDefaults(sizeValue) {
    return Object.assign({}, commonValues, sizeValues(sizeValue));
  };

  var sizeMarginDefaults = exports.sizeMarginDefaults = function sizeMarginDefaults(sizeValue) {
    return Object.assign({}, sizeDefaults(sizeValue), _defineProperty({}, MARGIN, '2px'));
  };

  var heightWidthDefaults = exports.heightWidthDefaults = function heightWidthDefaults(height, width) {
    return Object.assign({}, commonValues, heightWidthValues(height, width));
  };

  var heightWidthRadiusDefaults = exports.heightWidthRadiusDefaults = function heightWidthRadiusDefaults(height, width) {
    var _Object$assign4;

    var radius = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
    return Object.assign({}, heightWidthDefaults(height, width), (_Object$assign4 = {}, _defineProperty(_Object$assign4, RADIUS, radius), _defineProperty(_Object$assign4, RADIUS_UNIT, 'px'), _defineProperty(_Object$assign4, MARGIN, '2px'), _Object$assign4));
  };
});


//////////////////
// WEBPACK FOOTER
// ./~/react-spinners/helpers/proptypes.js
// module id = 58
// module chunks = 104158497352714 128747004913641